/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeEvery } from 'redux-saga/effects';
import AT from '../constants/action-types';

function handleHttpError(action: any) {
  switch (action.httpStatus) {
    case 401:
      if (/signin/.test(window.location.pathname) === false) {
        window.location.replace('/signin');
      }

      return;
    default:
      return;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* handleError(action: any) {
  if (action.httpStatus) {
    yield handleHttpError(action);
  }
}

export default function* httpErrorSaga() {
  yield takeEvery(AT.HTTP_ERROR_SAGA, handleError);
}
